module.exports = __webpack_public_path__ + "img/icon-weather.5a72b355.svg";